import { useDispatch, useSelector } from "react-redux";
import { OrganizationKeyName } from "../../model/Organization";
import * as userActions from "./userActions";
import * as authSelectors from "../auth/authSelectors";
import * as userSelectors from "./userSelectors";
import { SpinnerBlock } from "../common/Spinner";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { FormProvider, useForm } from "react-hook-form";
import { TextInput } from "../../components/forms/inputs/TextInput";

type Props = {
  onUserSelect: (userId: string, name: string) => void;
  onClose: () => void;
};

export const FindUserPopup = ({ onUserSelect, onClose }: Props) => {
  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );
  const dispatch = useDispatch();
  const isLoading = useSelector(userSelectors.isLoadingAutocomplete);
  const searchForUsers = (org: OrganizationKeyName, searchStr: string) => {
    dispatch(userActions.autocompleteUsersPopupAction(org, searchStr));
  };
  const users = useSelector(userSelectors.autocompleteUsers);
  const methods = useForm({
    defaultValues: {
      findBy: "",
    },
  });

  const onSubmit = (v: any) => {
    searchForUsers(organizationKeyName, v.findBy || "");
  };

  return (
    <Modal isOpen={true}>
      {/* @ts-ignore */}
      <FormProvider {...methods}>
        <form>
          <ModalHeader>Search for user</ModalHeader>
          <ModalBody>
            <div>
              <div className="form-group">
                <TextInput
                  name="findBy"
                  label="Search for user"
                  onChange={methods.handleSubmit(onSubmit)}
                />
              </div>
              {isLoading ? (
                <SpinnerBlock />
              ) : (
                <table className="table table-hover table-outline table-vcenter card-table">
                  <thead>
                    <tr>
                      <td>Name</td>
                      <td>Email</td>
                      <td />
                    </tr>
                  </thead>
                  <tbody>
                    {users.map((u) => (
                      <tr key={u.id}>
                        <td>{u.name}</td>
                        <td>{u.email}</td>
                        <td>
                          <button
                            className="btn btn-default"
                            onClick={(e) => {
                              e.preventDefault();
                              onUserSelect(u.id, u.name);
                            }}
                          >
                            Select
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-default"
              onClick={(e) => {
                e.preventDefault();
                onSubmit({ findBy: "" });
                onClose();
              }}
              disabled={isLoading}
            >
              Close
            </button>
          </ModalFooter>
        </form>
      </FormProvider>
    </Modal>
  );
};
